var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},_vm._l((_vm.options),function(item,index){return _c('el-radio',{key:index,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }